import { render, staticRenderFns } from "./AbkNewEventsBox.vue?vue&type=template&id=1ca36192&scoped=true&"
import script from "./AbkNewEventsBox.vue?vue&type=script&lang=js&"
export * from "./AbkNewEventsBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkNewEventsBox.vue?vue&type=style&index=0&id=1ca36192&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca36192",
  null
  
)

export default component.exports